module.exports = __webpack_public_path__ + "static/energy_18-96395c8042cc23ead7d3eaaa36307271.jpg";